module.exports = "/images/icon_loud03_sp.png?8f7a5b90f6658ac3ab73e03ee7a69c9a";